import React from "react";
import { makeStyles } from "@mui/styles";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    drawerFormContainer: {
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "24px"
    }
  };
});
var DrawerFormContainer = function DrawerFormContainer(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var classes = useStyles();
  return /*#__PURE__*/_jsx("div", {
    className: classNames(classes.drawerFormContainer, className),
    children: children
  });
};
export default DrawerFormContainer;